/**
 * Constants to be used in navigation components
 */

import type { NavItemType } from '@/router/types';

const profile: NavItemType = {
  name: 'profile',
  icon: 'fat fa-circle-user',
  label: 'navigation.go_to.my_profile',
  route: '/profile',
  external: false,
};

const network: NavItemType = {
  name: 'network',
  icon: 'fat fa-chart-network',
  label: 'candidate_profile.menu.tab_title_network',
  route: '/network',
  external: false,
};

const myCompany: NavItemType = {
  name: 'my-company',
  icon: 'fat fa-building',
  label: 'navigation.candidate.development',
  route: '/my-company',
  external: false,
};

const competencyFramework: NavItemType = {
  name: 'competency-framework',
  label: 'competency_framework.page.title',
  route: '/my-company/competency-framework',
  external: false,
};

const developmentPlan: NavItemType = {
  name: 'development-plans',
  label: 'competency_framework.recruiter.plan.tab_title',
  route: '/my-company/development-plans',
  external: false,
};

const jobInvitations: NavItemType = {
  name: 'jobInvitations',
  label: 'jobs.page.invitations.title',
  route: '/jobs/invitations',
  external: false,
};

const synthesisPE: NavItemType = {
  name: 'synthesisPE',
  label: 'navigation.profile.pe_summary',
  route: '/profile/france-travail',
  external: false,
};

const synthesis: NavItemType = {
  name: 'synthesis',
  label: 'navigation.profile.summary',
  route: '/profile/synthesis',
  external: false,
};

const careerPath: NavItemType = {
  name: 'careerPath',
  label: 'candidate_profile.menu.tab_title_career_paths',
  route: '/profile/career-path',
  external: false,
};

const networkInvitations: NavItemType = {
  name: 'networkInvitations',
  icon: 'fat fa-chart-network',
  label: 'manage_network.invitations.tab_title',
  route: '/network/invitations',
  external: false,
};

const networkContacts: NavItemType = {
  name: 'networkContacts',
  icon: 'fat fa-chart-network',
  label: 'manage_network.contacts.tab_title',
  route: '/network/contacts',
  external: false,
};

const networkCompanies: NavItemType = {
  name: 'networkCompanies',
  icon: 'fat fa-chart-network',
  label: 'manage_network.connected_companies.tab_title',
  route: '/network/companies',
  external: false,
};

const settings: NavItemType = {
  name: 'settings',
  icon: 'fat fa-gear',
  label: 'navigation.go_to.account_settings',
  route: '/settings',
  external: false,
};

const personalInfo: NavItemType = {
  name: 'settingsPersonalInfo',
  label: 'candidate_account.settings.tabs.account',
  route: '/settings/personal-info',
  external: false,
};

const login: NavItemType = {
  name: 'settingsLogin',
  label: 'candidate_account.settings.tabs.login',
  route: '/settings/login',
  external: false,
};

const privacy: NavItemType = {
  name: 'settingsPrivacy',
  label: 'candidate_account.settings.tabs.privacy',
  route: '/settings/privacy',
  external: false,
};

const recruiter: NavItemType = {
  name: 'recruiter',
  icon: 'fat fa-user-shield',
  label: 'candidate_profile.menu.tab_title_recruiter_portal',
  route: '/recruiter/contacts',
  external: true,
};

const admin: NavItemType = {
  name: 'admin',
  icon: 'fat fa-user-cog',
  label: 'navigation.go_to.admin_portal',
  route: '',
  external: true,
};

const manager: NavItemType = {
  name: 'manager',
  icon: 'fat fa-user-tag',
  label: 'navigation.go_to.manager_portal',
  route: '/manager/shared-candidates',
  external: true,
};

const help: NavItemType = {
  name: 'help',
  icon: 'fat fa-circle-question',
  label: 'navigation.help',
  route: '/knowledge',
  external: true,
  targetBlank: true,
};

export const logout: NavItemType = {
  name: 'logout',
  icon: 'fat fa-arrow-right-from-bracket',
  label: 'navigation.logout',
};

export const desktopHeaderNavItems: NavItemType[] = [profile, network, myCompany];

export const burgerNavItems: NavItemType[] = [recruiter, admin, manager, settings, help];

export const mobileNavItems: NavItemType[] = [profile, network, myCompany];

export const accountNavItems: NavItemType[] = [recruiter, admin, manager, settings, help];

export const profileTabNavItems: NavItemType[] = [synthesis, synthesisPE, careerPath];

export const settingsTabNavItems: NavItemType[] = [personalInfo, login, privacy];

export const networkTabNavItems: NavItemType[] = [
  networkInvitations,
  networkContacts,
  networkCompanies,
];

export const jobsTabNavItems: NavItemType[] = [jobInvitations];

export const myCompanyTabNavItems: NavItemType[] = [competencyFramework, developmentPlan];

export const mobileMyCompanyTabNavItems: NavItemType[] = [competencyFramework];
